import { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Box, Collapse, Flex } from '@chakra-ui/react';
import LaunchdeckModal from '../../../global/components/helper-components/components/LaunchdeckModal';
import { deleteAccount } from '../../../auth/actions/auth-actions';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import { generateRandomString } from '../../../global/helpers/global-helpers';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import { TbProgressAlert } from "react-icons/tb";
import { CgChevronDown } from 'react-icons/cg';

function DeleteOrganizationAccountModule({ orgName, deleteAccount }) {

  const confirmationText = (orgName) ? `delete-${orgName.trim()}-account` : `delete-${generateRandomString(6)}`;
  const displayConfirmationText = confirmationText && confirmationText.toLowerCase();
  const [deleteConfirmationText, setDeleteConfirmationText] = useState('');
  const [showConfirmationError, setShowConfirmationError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmationInput, setShowConfirmationInput] = useState(false)

  const handleChange = (event) => {
    const value = event.target.value;
    setDeleteConfirmationText(value);
  }

  const handleDeleteAccount = () => {
    if (!displayConfirmationText) {
      setShowConfirmationError(true)
    } else if (displayConfirmationText !== deleteConfirmationText.trim().toLowerCase()) {
      setShowConfirmationError(true)
    } else {
      setShowModal(true)
    }
  }

  const handleExecuteDeleteAccountFinal = async () => {
    await deleteAccount({ useCase: 'delete-organization' });
  }

  return (
    <Box w='100%'>
      <Flex justify='space-between' w='100%' align='flex-start'>

        <Box flex='9'>
          <Box className="user-profile-section__label"> Delete Organization </Box>
          <Box color='gray.500' maxWidth='500px' fontSize='0.8em' mt='-0.5em'>Proceed with caution: All users associated with {orgName}, all its Rooms and the content will all be removed. Any active subscription will also be cancelled.</Box>
        </Box>

        <Box flex='1' mt='0.75em' as={CgChevronDown} cursor='pointer' onClick={() => setShowConfirmationInput(!showConfirmationInput)} />
      </Flex>

      <Box mt='2em'>
        <Collapse in={showConfirmationInput} animateOpacity>

          <Box bg='gray.50' rounded='0.5em' p='0.5em'>
            <Box maxW='35em'>
            <LaunchdeckFormInput
              name="delete-confirm"
              onChange={(event) => handleChange(event)}
              // placeholder={`delete`}
              label="Delete Organization confirmation text"
              errorLogic={showConfirmationError}
              errorMessage={'Your input text did not match'}
            />
            </Box>
            <Box pl='0.5em'>
              <Box fontSize='0.8em' >To confirm, enter the following: <span style={{ fontStyle: 'italic' }} >{displayConfirmationText}</span></Box>
              <Flex direction='column' mt='1.5em' mb='1em' justify='center' alignItems='center'>
              <Flex justify={['center', 'flex-start']} w='100%'>
                <LaunchdeckButton bg='brandPink.500' color='white' onClick={handleDeleteAccount} label='Delete account' />
              </Flex>
            </Flex>
            </Box>
          </Box>
        </Collapse>
      </Box>


      <LaunchdeckModal
        title='Important Information'
        handleCloseModal={() => setShowModal(false)}
        showModal={showModal}
      >
        <Box p='1em 2em 2em 2em' >
          <Box> We are extremely sorry to see you want to go. We want to let you know what will happen once you acknowledge and proceed with this final step.</Box>

          <Flex mt='2.5em' justify='flex-start' align='center' fontWeight='600' gap={4}>
            <TbProgressAlert color='brandPink.500' />
            <Box color='gray.700'> Key Considerations</Box>
          </Flex>

          <Box whiteSpace='pre-line' mt='1em' fontSize='0.875em' color='gray.700'>{`1. All accounts associated with ${orgName} will no longer have access to Launchdeck. Once confirmed, we will not be able to restore the accounts. \n\n2. All Rooms, Prospectors and content created by ${orgName} members will also be removed permanently. \n\n3. Any non-essential personal information belonging to you will be removed. We only retain what is legally required of us (e.g by GDPR)`}
          </Box>

          <Box mt='6em' mb='1em' fontSize='0.8em' fontStyle='italic' textAlign='center'>I have read and understood the above considerations. By clicking the button below, I thereby confirm my decision to delete all accounts associated with my organization.</Box>

          <Flex w='100%' mt='2em' justify='center' alignItems='center'>
            <Flex justify='center' w='100%'>
              <LaunchdeckButton w='100%' bg="brand.500" color='white' onClick={() => setShowModal(false)} label='Keep Account' />
            </Flex>
          </Flex>

          <Flex w='100%' mt='1em' justify='center' alignItems='center'>
            <Flex justify='center' w='100%'>
              <LaunchdeckButton w='100%' bg="brandPink.500" color='white' onClick={handleExecuteDeleteAccountFinal} label='Confirm & delete organization' />
            </Flex>
          </Flex>


        </Box>

      </LaunchdeckModal>

    </Box>
  )
}



const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteAccount
    },
    dispatch,
  )


export default connect(null, mapDispatchToProps)(DeleteOrganizationAccountModule);